import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, List, ListItem } from "@material-ui/core";
import colors from "../../constants/colors";
import { InvoiceParsingError } from "../../models/Invoice";

interface InvoiceParsingErrorListDialogProps {
	//The list of errors to display.
	errorList: InvoiceParsingError[];
}

const useStyles = makeStyles((theme) => ({
	list: {
		minWidth: theme.breakpoints.values.md,
	},
}));

/**
 * This component is the dialog content component for the invoice parsing errors that occurred.
 * @param props
 */
export const InvoiceParsingErrorListDialog = (props: InvoiceParsingErrorListDialogProps) => {
	const classes = useStyles();
	return (
		<div>
			<List className={classes.list} data-testid={"invoice-parsing-error-dialog-list"}>
				{props.errorList.map((value, index) => (
					<ListItem key={index} data-testid="invoice-error-list-item">
						<div
							style={{
								backgroundColor: colors.gray100,
								boxShadow: "-1px 1px 1px gray",
								border: "1px solid",
								borderColor: colors.gray300,
								borderRadius: 5,
								width: "100%",
								minHeight: 50,
								padding: 5,
							}}
							data-testid={"error-list-item"}
						>
							<div>
								<Typography style={{ fontWeight: "bold" }}>Message:</Typography>
								<Typography>{value.message}</Typography>
								{value.rawRecord && (
									<div>
										<Typography style={{ fontWeight: "bold" }}>Raw Record: </Typography>
										<Typography>{value.rawRecord}</Typography>
									</div>
								)}
								{value.additionalNotes && (
									<div>
										<Typography style={{ fontWeight: "bold" }}>Additional Notes: </Typography>
										<Typography>{value.additionalNotes}</Typography>
									</div>
								)}
							</div>
						</div>
					</ListItem>
				))}
			</List>
		</div>
	);
};
